<div class="container">
  <div class="row justify-content-md-center ">
    <div clas="col col-lg-8">
      <div class="card mb-3">
        <div class="card-header backgroundHeader text-center">
            Sistema indisponível no momento, favor tentar mais tarde. (A001)
        </div>
        <div class="card-body backgroundBody text-center">
          <p class="card-text">  
               Se o problema persistir, contate nossa Central de Atendimento. <br>
                Consulte o telefone no sítio da CAIXA na Internet
            <a href="http://www.caixa.gov.br" target="_blank"> www.caixa.gov.br</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>